<template>
    <div class="containerInner">
        <div class="dispLoading">
            <LoadingLinear v-if="isLoading" />
        </div>
        <div class="homeContents" v-if="isLoading === false">
            <template v-if="apiLogs['regular'].length || apiLogs['mall'].length">
                <div class="apiBox">
                    <p>※取込エラーあり</p>
                    <div class="apiDetail">
                        <p v-for="log in apiLogs['regular']" :key="log">{{ getAdName(log) }}</p>
                        <p v-for="log in apiLogs['mall']" :key="log">{{ getMallAdName(log) }}</p>
                    </div>
                </div>
            </template>

            <div class="homeRanking">
                <div class="title">
                    <div class="titleLeft">
                        <h2>ランキング</h2>
                        <span class="scheduleTableIcon" title="定時処理の予定表" @click="showScheduleTable">
                            <Icon>help-circle-outline</Icon>
                        </span>
                    </div>
                    <a class="btn addBtn" @click="showExcludeRanking">ランキング除外設定</a>
                </div>
                <div class="dispMenu">
                    <div class="dispLeftMenu">
                        <div class="dispDateWrap">
                            <span class="dispDateUnit">
                                <PochiRadioToggleButtons v-model="rankingDateUnit" :values="dateUnitList" small
                                    text-color="#fff" />
                            </span>
                            <span class="dispCompare sp">
                                <input id="compare1" type="checkbox" name="compareCheck" @change="compareChecked"
                                    v-model="isCompareChecked" />
                                <label class="compareCheckBox" for="compare1">比較</label>
                            </span>
                            <span class="dispPeriod">
                                <div>
                                    <datepicker :minimumView="minView(rankingDateUnit)"
                                        :maximumView="maxView(rankingDateUnit)"
                                        :format="datepickerFormat(rankingDateUnit)" :language="ja"
                                        calendar-class="calendarDate" input-class="inputDate"
                                        v-model="rankingDatepickerStartDate" wrapper-class="dispPeriodInput"
                                        placeholder="開始日"
                                        :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                                    <span>〜</span>
                                    <datepicker :minimumView="minView(rankingDateUnit)"
                                        :maximumView="maxView(rankingDateUnit)"
                                        :format="datepickerFormat(rankingDateUnit)" :language="ja"
                                        calendar-class="calendarDate" input-class="inputDate"
                                        v-model="rankingDatepickerEndDate" wrapper-class="dispPeriodInput"
                                        placeholder="終了日"
                                        :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                                        :disabled-dates="{ to: rankingDatepickerStartDate }" />
                                </div>
                                <div v-if="isCompareChecked">
                                    <datepicker :minimumView="minView(rankingDateUnit)"
                                        :maximumView="maxView(rankingDateUnit)"
                                        :format="datepickerFormat(rankingDateUnit)" :language="ja"
                                        calendar-class="calendarDate" input-class="inputDate"
                                        v-model="rankingDatepickerStartDatePre" wrapper-class="dispPeriodInput"
                                        placeholder="開始日"
                                        :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                                    <span>〜</span>
                                    <datepicker :minimumView="minView(rankingDateUnit)"
                                        :maximumView="maxView(rankingDateUnit)"
                                        :format="datepickerFormat(rankingDateUnit)" :language="ja"
                                        calendar-class="calendarDate" input-class="inputDate"
                                        v-model="rankingDatepickerEndDatePre" wrapper-class="dispPeriodInput"
                                        placeholder="終了日"
                                        :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                                        :disabled-dates="{ to: rankingDatepickerStartDatePre }" />
                                </div>
                            </span>
                            <span>
                                <a class="btn borderNone applyBtn" v-on:click="updateRankingTable">適用</a>
                            </span>
                        </div>
                        <div>
                            <span class="dispCompare_sp">
                                <input id="compare2" type="checkbox" name="compareCheck" @change="compareChecked"
                                    v-model="isCompareChecked" />
                                <label class="compareCheckBox" for="compare2">比較</label>
                            </span>
                            <span class="dispSettingItem sp">表示日数</span>
                            <span class="sort-select">
                                <v-select name="periods" :options="periodOptions(rankingDateUnit)"
                                    v-model="rankingPeriod" :reduce="option => option.period"></v-select>
                            </span>
                            <span class="dispSettingItem2">メルマガ・LINE</span>
                            <span class="dispSettingItemRadio">
                                <toggle-button v-model="isExclusion" :sync="true"
                                    :color="{ checked: '#02adff', unchecked: '#02AD90' }" :height="30" :width="70"
                                    :labels="{ checked: '除外', unchecked: '含む' }"></toggle-button>
                            </span>
                        </div>

                    </div>
                    <div class="dispRightMenu">
                    </div>
                </div>



                <div class="dataControllMenu sp">
                    <div class="dataControllLeft">
                        <div class="tooltipsHover">
                            <Icon>clock</Icon>
                            <span class="tooltips">
                                最終更新日時<br>
                                {{ lastUpdate['yesterday'] }}
                            </span>
                        </div>
                        <a v-if="this.$store.state.isAccessableDev" class="btn" @click="showDataUpdate">データ更新</a>
                    </div>

                    <div class="dataControllBtn">
                        <a class="btn mr10" @click="csvDownload">CSVダウンロード</a>
                    </div>
                </div>

                <div class="rankingTab">
                    <button class="rankingTabBtn" @click="RankingDataBySite('0')"
                        v-bind:class="{ 'active': rankingTabActive == 0 }">全サイト</button>
                    <button class="rankingTabBtn" @click="RankingDataBySite('2')"
                        v-bind:class="{ 'active': rankingTabActive == 2 }">自社</button>
                    <button class="rankingTabBtn" @click="RankingDataBySite('3')"
                        v-bind:class="{ 'active': rankingTabActive == 3 }">楽天</button>
                    <button class="rankingTabBtn" @click="RankingDataBySite('4')"
                        v-bind:class="{ 'active': rankingTabActive == 4 }">Yahoo</button>
                    <button class="rankingTabBtn" @click="RankingDataBySite('5')"
                        v-bind:class="{ 'active': rankingTabActive == 5 }">Amazon</button>
                    <button class="rankingTabBtn" @click="RankingDataBySite('7')"
                        v-bind:class="{ 'active': rankingTabActive == 7 }">ZOZO</button>
                    <button class="rankingTabBtn" @click="RankingDataBySite('6')"
                        v-bind:class="{ 'active': rankingTabActive == 6 }">店舗</button>
                </div>

                <!-- 自社ショップタブ -->
                <div class="rankingShopTab" v-bind:class="{ 'active': rankingTabActive == 2 }">
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('30')"
                        v-bind:class="{ 'active': rankingShopTabActive == 30 }">amepla</button>
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('35')"
                        v-bind:class="{ 'active': rankingShopTabActive == 35 }">Nelture</button>
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('33')"
                        v-bind:class="{ 'active': rankingShopTabActive == 33 }">AZBS</button>
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('0')"
                        v-bind:class="{ 'active': rankingShopTabActive == 0 }">全て</button>
                </div>

                <!-- 楽天ショップタブ -->
                <div class="rankingShopTab" v-bind:class="{ 'active': rankingTabActive == 3 }">
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('4')"
                        v-bind:class="{ 'active': rankingShopTabActive == 4 }">amepla</button>
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('10')"
                        v-bind:class="{ 'active': rankingShopTabActive == 10 }">ﾈﾙﾁｬｰ</button>
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('0')"
                        v-bind:class="{ 'active': rankingShopTabActive == 0 }">全て</button>
                </div>

                <!-- Yahooショップタブ -->
                <div class="rankingShopTab" v-bind:class="{ 'active': rankingTabActive == 4 }">
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('26')"
                        v-bind:class="{ 'active': rankingShopTabActive == 26 }">ｱﾒﾌﾟﾗ&ﾈﾙﾁｬｰ</button>
                </div>

                <!-- Amazonショップタブ -->
                <div class="rankingShopTab" v-bind:class="{ 'active': rankingTabActive == 5 }">
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('28')"
                        v-bind:class="{ 'active': rankingShopTabActive == 28 }">amepla公式店</button>
                </div>

                <!-- ZOZOTOWNショップタブ -->
                <div class="rankingShopTab" v-bind:class="{ 'active': rankingTabActive == 7 }">
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('55')"
                        v-bind:class="{ 'active': rankingShopTabActive == 55 }">amepla</button>
                </div>

                <!-- 店舗タブ（店舗一覧は services/allByGroup ゲッター経由でDBから取得） -->
                <div class="rankingShopTab" v-bind:class="{ 'active': rankingTabActive == 6 }">
                    <button v-for="shop in shopTabs" :key="shop.id" class="rankingShopTabBtn"
                        @click="RankingDataByShop(shop.service_id)"
                        v-bind:class="{ 'active': rankingShopTabActive == shop.service_id }"
                        v-show="isShopVisible(shop.service_id)">{{ shop.name }}</button>
                    <button class="rankingShopTabBtn" @click="RankingDataByShop('0')"
                        v-bind:class="{ 'active': rankingShopTabActive == 0 }">全て</button>
                </div>


                <div class="rankingWrapper">
                    <div class="rankingDataContents" v-if="isLoadingRanking">
                        <LoadingLinear />
                    </div>
                    <div class="rankingDataContents" v-if="isLoadingRanking === false">
                        <RankingTable :ranking="ranking" :landingPages="landingPages"
                            :start_date="ranking_start_date.format('YYYY-MM-DD')"
                            :end_date="ranking_end_date.format('YYYY-MM-DD')"
                            :isAccessable="this.$store.state.isAccessable"
                            :isAccessableDev="this.$store.state.isAccessableDev" :rankingTabActive="rankingTabActive"
                            :isOrderAscRank="'sales_desc'" :service_id=serviceIds />
                    </div>
                </div>
            </div>
            <div class="homeRoas">
                <div class="dispType">
                    <div class="title">
                        <h2>全商品ROAS</h2>
                    </div>
                    <div class="typeItemWrap">
                        <div class="typeItem" @click="selectTotallingMenu(totallingMenus.productAndMall)">
                            <div
                                :class="[this.selectedTotallingMenu == this.totallingMenus.productAndMall ? 'onDisp' : 'offDisp']">
                                表示中
                            </div>
                            <div class="totallingMenu">自社･モール合計</div>
                        </div>
                        <div class="typeItem" @click="selectTotallingMenu(totallingMenus.site)">
                            <div
                                :class="[this.selectedTotallingMenu == this.totallingMenus.site ? 'onDisp' : 'offDisp']">
                                表示中</div>
                            <div class="totallingMenu">サイト合計</div>
                        </div>
                    </div>
                </div>
                <div class="dispMenu">
                    <div class="dispLeftMenu">
                        <span class="dispDateUnit">
                            <PochiRadioToggleButtons v-model="roasDateUnit" :values="dateUnitList" small
                                text-color="#fff" />
                        </span>
                        <span class="dispPeriod">
                            <datepicker :minimumView="minView(roasDateUnit)" :maximumView="maxView(roasDateUnit)"
                                :format="datepickerFormat(roasDateUnit)" :language="ja" calendar-class="calendarDate"
                                input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="開始日"
                                v-model="roasDatepickerStartDate"
                                :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }" />
                            <span>〜</span>
                            <datepicker :minimumView="minView(roasDateUnit)" :maximumView="maxView(roasDateUnit)"
                                :format="datepickerFormat(roasDateUnit)" :language="ja" calendar-class="calendarDate"
                                input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="終了日"
                                v-model="roasDatepickerEndDate"
                                :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                                :disabled-dates="{ to: roasDatepickerStartDate }" />
                        </span>
                        <span>
                            <a class="btn borderNone applyBtn" @click="updateTable">適用</a>
                        </span>
                        <span class="dispSettingItem sp">表示日数</span>
                        <span class="sort-select">
                            <v-select name="periods" :options="periodOptions(roasDateUnit)" v-model="roasPeriod"
                                :reduce="option => option.period"></v-select>
                        </span>
                        <span class="dispSettingItem2">メルマガ・LINE</span>
                        <span class="dispSettingItemRadio">
                            <toggle-button v-model="isExclusion_roas" :sync="true"
                                :color="{ checked: '#02adff', unchecked: '#02AD90' }" :height="30" :width="70"
                                :labels="{ checked: '除外', unchecked: '含む' }"></toggle-button>
                        </span>
                    </div>
                    <div class="dispRightMenu">
                    </div>
                </div>


                <div class="dispMenu_white">
                    <div class="dispLeftMenu sp">
                    </div>
                    <div class="dispRightMenu">
                        <div class="dataControllBtn">
                            <template v-if="selectedTotallingMenu === totallingMenus.productAndMall">
                                <a class="btn sp" @click="csvDownloadOwnAndMall">CSVダウンロード</a>
                            </template>
                            <template v-if="selectedTotallingMenu === totallingMenus.site">
                                <a class="btn sp" @click="csvDownloadSite">CSVダウンロード</a>
                            </template>
                        </div>
                    </div>
                </div>


                <div class="dispDataContents" v-if="isLoadingRoas">
                    <LoadingLinear />
                </div>
                <div class="dispDataContents"
                    v-if="selectedTotallingMenu === totallingMenus.productAndMall && isLoadingRoas === false">
                    <ProductMallTable :is-order-asc="false" :performanceReports="performanceReports"
                        :service-reports="serviceReports" :is-monthly="isMonthlyGrouped" :dateUnit="roas_date_unit"
                        :show-costs="this.$store.state.isAccessable" :roas-hidden-from="roasHiddenFrom" />
                </div>
                <div class="dispDataContents"
                    v-if="selectedTotallingMenu === totallingMenus.site && isLoadingRoas === false">
                    <SiteTable :is-order-asc="isOrderAsc" :performance-reports="performanceReports"
                        :is-monthly="isMonthlyGrouped" :dateUnit="roas_date_unit"
                        :startDate="this.roas_start_date.format('YYYY-MM-DD')" :endDate="this.roas_end_date"
                        :roas-hidden-from="roasHiddenFrom" />
                </div>
            </div>
            <modal name="excludeRanking" :draggable="false" :resizable="false" width="85%" height="80%">
                <ExcludeRanking modal-type="roasProduct" @modalClosed="excludeRankingModalClosed" />
            </modal>
            <modal name="dataUpdate" :draggable="false" :resizable="false" width="50%" height="560px">
                <div class="modal_dataUpdate">
                    <div class="header">
                        <h3>データ更新（日次バッチ手動実行）</h3>
                    </div>
                    <div class="dataUpdate_period">
                        <span class="dataUpdate_periodLabel">対象期間</span>
                        <span class="dispPeriod">
                            <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                                input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="開始日"
                                v-model="batchStartDate"
                                :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                                :disabled-dates="{ from: batchDisabledFrom }" />
                            <span>〜</span>
                            <datepicker format="yyyy-MM-dd" :language="ja" calendar-class="calendarDate"
                                input-class="inputDate" wrapper-class="dispPeriodInput" placeholder="終了日"
                                v-model="batchEndDate"
                                :highlighted="{ includeDisabled: true, ...$store.getters['holidays/datepickerHighlighted'] }"
                                :disabled-dates="{ to: batchStartDate, from: batchDisabledFrom }" />
                        </span>
                    </div>
                    <p class="dataUpdate_note">※更新には時間がかかる場合があります。</p>
                    <div class="dataUpdate_btns">
                        <Button class="cancelBtn" @click="closeDataUpdate">キャンセル</Button>
                        <Button class="btn updateBtn" @click="executeDataUpdate">更新</Button>
                    </div>
                </div>
            </modal>
            <modal name="scheduleTable" :draggable="false" :resizable="false" width="70%" height="auto"
                :scrollable="true">
                <ScheduleTableModal />
            </modal>
        </div>
        <div class="loading-window" v-show="this.$store.state.loading">
            <div class="loading-window-inner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>
import RankingTable from '../components/RankingTable.vue'
import ExcludeRanking from './ExcludeRanking.vue'
import ProductMallTable from '../components/ProductMallTable.vue'
import SiteTable from '../components/SiteTable.vue'
import ScheduleTableModal from '../components/ScheduleTableModal.vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import { saveAs } from 'file-saver'
import Encoding from 'encoding-japanese'
import { mapGetters } from 'vuex';

const DATE_UNIT_TYPE = {
    MONTH: 'month',
    WEEK: 'week',
    DAY: 'day',
};

export default {
    components: {
        RankingTable,
        ExcludeRanking,
        ProductMallTable,
        SiteTable,
        ScheduleTableModal,
        Datepicker
    },
    data() {
        return {
            ja: ja,
            isLoading: true,
            isLoadingRanking: true,
            isLoadingRoas: true,
            isCompareChecked: false,
            ranking_date_unit: DATE_UNIT_TYPE.DAY,
            roas_date_unit: DATE_UNIT_TYPE.DAY,
            performanceReports: {},
            ranking: {},
            ranking_start_date: this.$dayjs().startOf('date').subtract(1, 'day'),
            ranking_end_date: this.$dayjs().endOf('date').subtract(1, 'day'),
            ranking_start_date_pre: this.$dayjs().startOf('date').subtract(2, 'day'),
            ranking_end_date_pre: this.$dayjs().endOf('date').subtract(2, 'day'),
            roas_start_date: this.$dayjs().startOf('date').subtract(7, 'day'),
            roas_end_date: this.$dayjs().endOf('date').subtract(1, 'day'),
            ranking_period: 1,
            roas_period: 7,
            rankingTabActive: 0,
            rankingShopTabActive: 0,
            serviceIds: [0],
            shopVisibility: {},
            selectedTotallingMenu: "site",
            totallingMenus: {
                productAndMall: 'productAndMall',
                site: 'site',
            },
            isOrderAsc: false,
            landingPages: {},
            isExclusion: false,
            isExclusion_roas: false,
            serviceReports: {},
            // 取得前の描画で apiLogs['regular'].length が落ちないよう、レスポンスと同じ形で初期化する
            apiLogs: { regular: [], mall: [] },
            lastUpdate: [],
            // 集計済みの最新日（注文日ベース）。取得できない場合は null
            latestDate: null,
            batchStartDate: this.$dayjs().startOf('date').subtract(1, 'day').toDate(),
            batchEndDate: this.$dayjs().startOf('date').subtract(1, 'day').toDate(),
        }
    },
    mounted: async function () {
        // 店舗一覧（state.shops）のロード完了を待ってから全集計を取得する
        // （待たないと shopServiceIds が空のまま初回リクエストが飛び、店舗集計が反映されない）
        await this.$store.dispatch('services/fetchShops');
        // 集計済みの最新日を取得し、それを基準に表示期間を設定してから各データを取得する
        await this.getLastUpdate();
        this.resetDisplayDates();
        // 初期表示は全集計
        this.RankingDataBySite(0);
        this.fetchProductData();
        this.fetchLandingPages();
        this.fetchServiceAdCosts();
        this.getApiLogs();
    },
    methods: {
        getApiLogs() {
            this.axios.get('/api/newApiLogs')
                .then((res) => {
                    this.apiLogs = res.data;
                }).catch(() => {
                }).finally(() => {
                })
        },
        getAdName(log) {
            const ad = this.media.api.find(item => item[0] === log);
            return ad ? ad[1] : null;
        },
        getMallAdName(log) {
            const ad = this.media.mallApi.find(item => item[0] === log);
            return ad ? ad[1] : null;
        },
        getLastUpdate() {
            // 失敗しても latestDate は null のまま（今日基準で表示を続ける）
            return this.axios.get('/api/lastSummaryUpdate')
                .then((res) => {
                    this.lastUpdate = res.data;
                    this.latestDate = res.data.latest_date || null;
                }).catch(() => {
                }).finally(() => {
                })
        },
        //表示期間の基準日（集計済みの最新日の翌日。最新日が無ければ今日）
        //昼間は最新日=昨日なので基準日=今日、夜の集計後は最新日=今日なので基準日=明日になる
        baseDate() {
            if (this.latestDate) {
                return this.$dayjs(this.latestDate).add(1, 'day').startOf('date');
            }
            return this.$dayjs().startOf('date');
        },
        //表示期間を基準日から初期値に設定し直す（ランキング：前日1日分、ROAS：直近7日分）
        resetDisplayDates() {
            const base = this.baseDate();
            this.ranking_start_date = base.subtract(1, 'day');
            this.ranking_end_date = base.endOf('date').subtract(1, 'day');
            this.ranking_start_date_pre = base.subtract(2, 'day');
            this.ranking_end_date_pre = base.endOf('date').subtract(2, 'day');
            this.roas_start_date = base.subtract(7, 'day');
            this.roas_end_date = base.endOf('date').subtract(1, 'day');
        },
        updateTable() {
            this.fetchProductData();
            this.fetchServiceAdCosts();
        },
        updateRankingTable() {
            //店舗タブを開いている場合は「全て」を初期表示に戻してから再検索する
            //（指定期間に存在しない店舗を開いたまま再検索すると0円表示になってしまうため）
            if (this.rankingTabActive == 6) {
                this.rankingShopTabActive = 0;
                this.serviceIds = [...this.shopServiceIds];
                this.fetchShopVisibility(this.shopServiceIds);
            }
            this.fetchRankingData();
        },
        //ランキング取得
        fetchRankingData() {
            this.isLoadingRanking = true;
            let url = '/api/ranking';
            // 比較チェックされていない場合は、前期間を指定
            if (!this.isCompareChecked) {
                this.resetRankingDatePre();
            }
            var params = {
                start_date: this.ranking_start_date.format("YYYY-MM-DD"),
                end_date: this.ranking_end_date.format("YYYY-MM-DD"),
                start_date_pre: this.ranking_start_date_pre.format("YYYY-MM-DD"),
                end_date_pre: this.ranking_end_date_pre.format("YYYY-MM-DD"),
                order_by: 0,
                service_id: this.serviceIds,
                is_exclusion: this.isExclusion,
            }
            this.axios.get(url, { params: params })
                .then((res) => {
                    this.ranking = { ...res.data };
                }).catch(() => {
                }).finally(() => {
                    this.isLoadingRanking = false;
                    this.isLoading = false;
                })

        },
        fetchShopVisibility(serviceIds) {
            var params = {
                start_date: this.ranking_start_date.format("YYYY-MM-DD"),
                end_date: this.ranking_end_date.format("YYYY-MM-DD"),
                service_id: serviceIds,
            }
            this.axios.get('/api/ranking/shopSummary', { params: params })
                .then((res) => {
                    var visibility = {};
                    for (const id of serviceIds) {
                        var data = res.data[id];
                        visibility[id] = data && (data.sales > 0 || data.units > 0);
                    }
                    this.shopVisibility = visibility;
                }).catch(() => {
                })
        },
        isShopVisible(shopId) {
            if (Object.keys(this.shopVisibility).length === 0) return true;
            return !!this.shopVisibility[shopId];
        },
        //指定モールの service_id 一覧を services.js から取得する
        mallServiceIdsOf(mallId) {
            const mall = this.servicesByGroup.malls.find(m => m.id === mallId);
            return mall ? mall.services.map(s => s.service_id) : [];
        },
        fetchLandingPages() {
            this.axios.get("/api/products/lp")
                .then((res) => {
                    this.landingPages = { ...res.data };
                }).catch(() => {
                }).finally(() => {
                });
        },
        //全商品ROAS用
        fetchProductData() {
            this.isLoadingRoas = true;
            let url = '';
            switch (this.selectedTotallingMenu) {
                case this.totallingMenus.productAndMall:
                    url = '/api/productRoasByOwnAndMall';
                    break;
                case this.totallingMenus.site:
                    url = '/api/productRoasBySites';
                    break;
            }
            this.isMonthlyGrouped = this.roas_date_unit === DATE_UNIT_TYPE.MONTH

            this.axios.get(url, {
                params: {
                    searchStartedAt: this.roas_start_date.format("YYYY-MM-DD"),
                    searchEndedAt: this.roas_end_date.format("YYYY-MM-DD"),
                    productId: -1,
                    totallingTargetId: null,
                    serviceId: -1,
                    order: 'asc',
                    isSaleShipmentDateBased: false,
                    isByMonth: this.isMonthlyGrouped,
                    dateUnit: this.roas_date_unit,
                    is_exclusion_roas: this.isExclusion_roas,
                }
            })
                .then((res) => {
                    this.performanceReports = { ...res.data };
                }).catch(() => {
                }).finally(() => {
                    this.isLoadingRoas = false;
                    this.isLoading = false;
                })
        },
        fetchServiceAdCosts() {
            var url = "/api/service/adCosts";
            var data = {
                start_date: this.roas_start_date.format("YYYY-MM-DD"),
                end_date: this.roas_end_date.format("YYYY-MM-DD"),
                dateUnit: this.roas_date_unit,
                service_id: -1,
            }
            this.axios.get(url, { params: data })
                .then((res) => {
                    this.serviceReports = { ...res.data };
                }).catch(() => {
                }).finally(() => {
                });
        },
        selectTotallingMenu(selectedTotallingMenu) {
            // 表示データ切替え(自社･モール別 or サイト別 or 費用分析)
            this.isLoadingRoas = true;
            this.selectedTotallingMenu = selectedTotallingMenu
            this.updateTable();
        },
        showDataUpdate() {
            this.$modal.show('dataUpdate')
        },
        closeDataUpdate() {
            this.$modal.hide('dataUpdate')
        },
        showScheduleTable() {
            this.$modal.show('scheduleTable')
        },
        executeDataUpdate() {
            const params = {
                start_day: this.$dayjs(this.batchStartDate).format('YYYY-MM-DD'),
                end_day: this.$dayjs(this.batchEndDate).format('YYYY-MM-DD'),
            };
            // 集計完了までローディング表示を出しておく（モーダルは完了後に閉じる）
            this.$store.dispatch("loading", true);
            this.axios.post('/api/summary/dailyBatch', params)
                .then(() => {
                    // 更新後のデータを再取得する
                    this.getLastUpdate();
                    this.updateTable();
                    this.fetchRankingData();
                }).catch(() => {
                    alert('データ更新に失敗しました。');
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                    this.$modal.hide('dataUpdate')
                });
        },
        showExcludeRanking() {
            this.modalShow = true
            this.$modal.show('excludeRanking')
        },
        excludeRankingModalClosed() {
            this.modalShow = false
            this.$modal.hide('excludeRanking')
        },
        compareChecked: function () {

        },
        minView: function (dateUnit) {
            switch (dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                    return 'month';
                case DATE_UNIT_TYPE.WEEK:
                case DATE_UNIT_TYPE.DAY:
                    return 'day';
            }
            return null;
        },
        maxView: function (dateUnit) {
            switch (dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                case DATE_UNIT_TYPE.WEEK:
                case DATE_UNIT_TYPE.DAY:
                    return 'year';
            }
            return null;
        },
        datepickerFormat: function (dateUnit) {
            switch (dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                    return 'yyyy-MM';
                case DATE_UNIT_TYPE.WEEK:
                case DATE_UNIT_TYPE.DAY:
                    return 'yyyy-MM-dd';
            }
            return null;
        },
        periodOptions: function (dateUnit) {
            switch (dateUnit) {
                case DATE_UNIT_TYPE.MONTH:
                    return [
                        { label: '検索期間', period: null },
                        { label: '1年間', period: 12 },
                        { label: '2年間', period: 24 },
                        { label: '決算月〜', period: 'closing-month' },
                    ];
                case DATE_UNIT_TYPE.WEEK:
                    return [
                        { label: '検索期間', period: null },
                        { label: '1週間', period: 7 },
                        { label: '2週間', period: 14 },
                        { label: '3週間', period: 21 },
                        { label: '4週間', period: 28 },
                        { label: '決算月〜', period: 'closing-month' },
                    ];
                case DATE_UNIT_TYPE.DAY:
                    return [
                        { label: '検索期間', period: null },
                        { label: '1日間', period: 1 },
                        { label: '7日間', period: 7 },
                        { label: '14日間', period: 14 },
                        { label: '21日間', period: 21 },
                        { label: '30日間', period: 30 },
                        { label: '決算月〜', period: 'closing-month' },
                    ];
                default:
                    return [];
            }
        },


        //CSVダウンロード
        csvDownload() {
            let url = '/api/ranking/csv';

            let start_date = this.ranking_start_date.format("YYYY-MM-DD");
            let end_date = this.ranking_end_date.format("YYYY-MM-DD");
            let start_date_pre = this.ranking_start_date_pre.format("YYYY-MM-DD");
            let end_date_pre = this.ranking_end_date_pre.format("YYYY-MM-DD");
            let order_by = 0;
            let date_unit = this.ranking_date_unit;

            this.axios.get(url, {
                params: {
                    start_date,
                    end_date,
                    start_date_pre,
                    end_date_pre,
                    order_by,
                    date_unit,
                    service_id: this.serviceIds,
                    is_exclusion: this.isExclusion,
                }
            })

                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // save
                    const fileName = 'ランキングCSV(' + start_date + '～' + end_date + ').csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },
        //ROASのCSVダウンロード
        csvDownloadOwnAndMall() {
            let url = '/api/productRoasByOwnAndMall/csv';

            let start_date = this.roas_start_date.format('YYYY-MM-DD');
            let end_date = this.roas_end_date.format('YYYY-MM-DD');

            this.axios.get(url, {
                params: {
                    searchStartedAt: start_date,
                    searchEndedAt: end_date,
                    productId: -1,
                    totallingTargetId: null,
                    serviceId: -1,
                    order: 'asc',
                    isSaleShipmentDateBased: false,
                    isByMonth: this.isMonthlyGrouped,
                    dateUnit: this.roas_date_unit,
                    is_exclusion_roas: this.isExclusion_roas,
                    period_type: null,
                }
            })

                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // save
                    const fileName = '全商品' + '(' + start_date + '～' + end_date + ').csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },
        csvDownloadSite() {
            let url = '/api/productRoasBySites/csv';

            let start_date = this.roas_start_date.format('YYYY-MM-DD');
            let end_date = this.roas_end_date.format('YYYY-MM-DD');

            this.axios.get(url, {
                params: {
                    searchStartedAt: start_date,
                    searchEndedAt: end_date,
                    productId: -1,
                    totallingTargetId: null,
                    serviceId: -1,
                    order: 'asc',
                    isSaleShipmentDateBased: false,
                    isByMonth: this.isMonthlyGrouped,
                    dateUnit: this.roas_date_unit,
                    is_exclusion_roas: this.isExclusion_roas,
                    period_type: null,
                }
            })

                .then((res) => {
                    // convert encoding. (utf-8 → shift-jis)
                    const unicodeList = Encoding.stringToCode(res.data);
                    const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                    const shiftJisString = new Uint8Array(shiftJisCodeList);

                    // save
                    const fileName = 'サイト合計_' + '全商品' + '(' + start_date + '～' + end_date + ').csv'
                    let blob = new Blob([shiftJisString], { type: 'text/csv;charset=sjis' })
                    saveAs(blob, fileName);
                }).catch(e => {
                    this.$message.error(e.response.data.message)
                })
        },

        //ランキングサイト別集計
        //サイトが変更されたらショップ別のランキング再取得
        RankingDataBySite(siteId) {
            this.rankingTabActive = Number(siteId);

            this.rankingShopTabActive = 0;

            //全サイト（services.js のIDはストアから取得、無いIDはハードコードで残す）
            if (this.rankingTabActive == 0) {
                this.serviceIds = [
                    ...this.inHouseServiceIds, ...this.mallServiceIds, ...this.shopServiceIds,
                    40, 5, 7, 41, 34, 38, 37
                ];
            }

            //自社（services.js のIDはストアから取得、無いIDはハードコードで残す）
            else if (this.rankingTabActive == 2) {
                this.serviceIds = [...this.inHouseServiceIds, 40];
            }

            //楽天（services.js のIDはストアから取得、無いIDはハードコードで残す）
            else if (this.rankingTabActive == 3) {
                this.serviceIds = [...this.mallServiceIdsOf('rakuten'), 5, 7, 41];
            }

            //Yahoo
            else if (this.rankingTabActive == 4) {
                this.serviceIds = [...this.mallServiceIdsOf('yahoo')];
                this.rankingShopTabActive = 26;
            }

            //Amazon
            else if (this.rankingTabActive == 5) {
                this.serviceIds = [...this.mallServiceIdsOf('amazon')];
                this.rankingShopTabActive = 28;
            }

            //ZOZOTOWN
            else if (this.rankingTabActive == 7) {
                this.serviceIds = [...this.mallServiceIdsOf('zozo')];
                this.rankingShopTabActive = 55;
            }

            //店舗
            else if (this.rankingTabActive == 6) {
                this.serviceIds = [...this.shopServiceIds];
                this.fetchShopVisibility(this.shopServiceIds);
            }

            this.fetchRankingData();
        },

        //ランキングショップ別集計
        //ショップが変更されたらショップ別のランキング再取得
        RankingDataByShop(shopId) {
            this.rankingShopTabActive = Number(shopId);

            //自社「全て」（services.js のIDはストアから取得、無いIDはハードコードで残す）
            if (this.rankingTabActive == 2 && shopId == 0) {
                this.serviceIds = [...this.inHouseServiceIds, 40];
            }

            //楽天「全て」（services.js のIDはストアから取得、無いIDはハードコードで残す）
            else if (this.rankingTabActive == 3 && shopId == 0) {
                this.serviceIds = [...this.mallServiceIdsOf('rakuten'), 5, 7, 41];
            }

            //Yahoo「全て」（services.js のIDはストアから取得、無いIDはハードコードで残す）
            else if (this.rankingTabActive == 4 && shopId == 0) {
                this.serviceIds = [...this.mallServiceIdsOf('yahoo'), 34, 38];
            }

            //Amazon「全て」（services.js のIDはストアから取得、無いIDはハードコードで残す）
            else if (this.rankingTabActive == 5 && shopId == 0) {
                this.serviceIds = [...this.mallServiceIdsOf('amazon'), 37];
            }

            //ZOZOタウン「全て」
            else if (this.rankingTabActive == 7 && shopId == 0) {
                this.serviceIds = [...this.mallServiceIdsOf('zozo')];
            }

            //店舗「全て」
            else if (this.rankingTabActive == 6 && shopId == 0) {
                this.serviceIds = [...this.shopServiceIds];
            }

            else {
                this.serviceIds = [shopId];
            }

            this.fetchRankingData();
        },
        resetRankingDatePre() {
            var start_date_pre = this.ranking_start_date_pre;
            var end_date_pre = this.ranking_end_date_pre;
            var date_diff = 0;
            if (this.dateUnit == DATE_UNIT_TYPE.MONTH) {
                date_diff = this.ranking_end_date.diff(this.ranking_start_date, 'm') + 1;
                start_date_pre = this.ranking_start_date.subtract(date_diff, 'm').startOf('month');
                end_date_pre = this.ranking_end_date.subtract(date_diff, 'm').endOf('month');
            } else {
                date_diff = this.ranking_end_date.diff(this.ranking_start_date, 'd') + 1;
                start_date_pre = this.ranking_start_date.subtract(date_diff, 'd');
                end_date_pre = this.ranking_end_date.subtract(date_diff, 'd');
            }
            this.ranking_start_date_pre = start_date_pre;
            this.ranking_end_date_pre = end_date_pre;
        }

    },
    watch: {
        // 開始日が終了日より後になった場合、終了日を開始日に合わせる
        batchStartDate: function (date) {
            if (date > this.batchEndDate) {
                this.batchEndDate = date;
            }
        },
        rankingPeriod: {
            handler: function () {
                this.resetRankingDatePre();
                this.fetchRankingData();
                if (this.rankingTabActive == 6) {
                    this.fetchShopVisibility(this.shopServiceIds);
                }
            },
        },
        rankingDateUnit: {
            handler: function () {
                this.resetRankingDatePre();
                this.fetchRankingData();
                this.ranking_period = null;
                if (this.rankingTabActive == 6) {
                    this.fetchShopVisibility(this.shopServiceIds);
                }
            },
        },
        roasPeriod: {
            handler: function () {
                this.fetchProductData();
                this.fetchServiceAdCosts();
            },
        },
        roasDateUnit: {
            handler: function () {
                this.fetchProductData();
                this.fetchServiceAdCosts();
                this.roas_period = null;
            },
        },
        isExclusion: {
            handler: function () {
                this.fetchRankingData();
            }
        },
        isExclusion_roas: {
            handler: function () {
                this.updateTable();
            }
        }
    },
    computed: {
        //全商品ROAS：広告費がまだ入っていない日（この日以降）の ROAS を「-」にする
        //当日分の売上は夜の集計で入るが、広告費は翌朝4時の取込で前日分が入るため、
        //夜〜翌朝5時はその日の ROAS が極端な値になる。期間に含まないときは null
        roasHiddenFrom() {
            const from = this.$dayjs().subtract(5, 'hour').format('YYYY-MM-DD');
            return this.$dayjs(this.roas_end_date).format('YYYY-MM-DD') >= from ? from : null;
        },

        //日付選択時の画面表示日付の設定
        //週次の場合、自由に1週間を設定できるようにする（日曜～土曜で固定しないため既存関数は使わない）

        //ランキング 開始日
        rankingDatepickerStartDate: {
            get: function () { return this.ranking_start_date.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (date > this.ranking_end_date) {
                    this.ranking_end_date = this.$dayjs(date).startOf(this.rankingDateUnit);
                }

                //週次の場合
                if (this.rankingDateUnit == 'week') {
                    //開始日に選択された日付セット
                    this.ranking_start_date = this.$dayjs(date).startOf('day');

                    //終了日に開始日の1週間後をセット
                    this.ranking_end_date = this.$dayjs(this.ranking_start_date).endOf('date').add(6, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.ranking_end_date = (this.ranking_end_date < yesterday) ? this.ranking_end_date : yesterday;
                }

                //日次・月次の場合
                else {
                    this.ranking_start_date = this.$dayjs(date).startOf(this.rankingDateUnit);
                }
                this.resetRankingDatePre();
            },
        },

        //ランキング 終了日
        rankingDatepickerEndDate: {
            get: function () { return this.ranking_end_date.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (this.ranking_start_date > date) {
                    date = this.ranking_start_date;
                }

                //週次の場合
                if (this.rankingDateUnit == 'week') {
                    //開始日と終了日の日数差を取得
                    const diff = this.$dayjs(date).diff(this.$dayjs(this.ranking_start_date));

                    //何週間空いているかに変換
                    const weeks = Math.floor(this.$dayjs.duration(diff).asWeeks());

                    //開始日のweeks週間後をセット
                    const addDay = 7 * (weeks + 1) - 1;
                    this.ranking_end_date = this.$dayjs(this.ranking_start_date).endOf('date').add(addDay, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.ranking_end_date = (this.ranking_end_date < yesterday) ? this.ranking_end_date : yesterday;
                }

                //日次・月次の場合
                else {
                    this.ranking_end_date = this.$dayjs(date).endOf(this.rankingDateUnit);
                }
                this.resetRankingDatePre();
            },
        },

        //ランキング 期間比開始日
        rankingDatepickerStartDatePre: {
            get: function () { return this.ranking_start_date_pre.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (date > this.ranking_end_date_pre) {
                    this.ranking_end_date_pre = this.$dayjs(date).startOf(this.rankingDateUnit);
                }

                //週次の場合
                if (this.rankingDateUnit == 'week') {
                    //開始日に選択された日付セット
                    this.ranking_start_date_pre = this.$dayjs(date).startOf('day');

                    //終了日に開始日の1週間後をセット
                    this.ranking_end_date_pre = this.$dayjs(this.ranking_start_date_pre).endOf('date').add(6, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.ranking_end_date_pre = (this.ranking_end_date_pre < yesterday) ? this.ranking_end_date_pre : yesterday;
                }

                //日次・月次の場合
                else {
                    this.ranking_start_date_pre = this.$dayjs(date).startOf(this.rankingDateUnit);
                }
            },
        },

        //ランキング 期間比終了日
        rankingDatepickerEndDatePre: {
            get: function () { return this.ranking_end_date_pre.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (this.ranking_start_date_pre > date) {
                    date = this.ranking_start_date_pre;
                }

                //週次の場合
                if (this.rankingDateUnit == 'week') {
                    //開始日と終了日の日数差を取得
                    const diff = this.$dayjs(date).diff(this.$dayjs(this.ranking_start_date_pre));

                    //何週間空いているかに変換
                    const weeks = Math.floor(this.$dayjs.duration(diff).asWeeks());

                    //開始日のweeks週間後をセット
                    const addDay = 7 * (weeks + 1) - 1;
                    this.ranking_end_date_pre = this.$dayjs(this.ranking_start_date_pre).endOf('date').add(addDay, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.ranking_end_date_pre = (this.ranking_end_date_pre < yesterday) ? this.ranking_end_date_pre : yesterday;
                }

                //日次・月次の場合
                else {
                    this.ranking_end_date_pre = this.$dayjs(date).endOf(this.rankingDateUnit);
                }
            },
        },

        //日次バッチ手動実行 開始日・終了日の選択可能上限（昨日まで）
        //disabled-dates の from は「fromより後」を無効にするため、昨日を渡して今日以降を無効にする
        batchDisabledFrom: function () {
            return this.$dayjs().startOf('date').subtract(1, 'day').toDate();
        },

        //ROAS開始日
        roasDatepickerStartDate: {
            get: function () { return this.roas_start_date.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (date > this.roas_end_date) {
                    this.roas_end_date = this.$dayjs(date).startOf(this.rankingDateUnit);
                }

                //週次の場合
                if (this.roasDateUnit == 'week') {
                    //開始日に選択された日付セット
                    this.roas_start_date = this.$dayjs(date).startOf('day');

                    //終了日に開始日の1週間後をセット
                    this.roas_end_date = this.$dayjs(this.roas_start_date).endOf('date').add(6, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.roas_end_date = (this.roas_end_date < yesterday) ? this.roas_end_date : yesterday;
                }

                //日次・月次の場合
                else {
                    this.roas_start_date = this.$dayjs(date).startOf(this.roasDateUnit);
                }
            },
        },

        //ROAS終了日
        roasDatepickerEndDate: {
            get: function () { return this.roas_end_date.toDate(); },
            set: function (date) {
                //開始日のほうが大きい場合、終了日にも同じ日付セット
                if (this.roas_start_date > date) {
                    date = this.roas_start_date;
                }

                //週次の場合
                if (this.roasDateUnit == 'week') {
                    //開始日と終了日の日数差を取得
                    const diff = this.$dayjs(date).diff(this.$dayjs(this.roas_start_date));

                    //何週間空いているかに変換
                    const weeks = Math.floor(this.$dayjs.duration(diff).asWeeks());

                    //開始日のweeks週間後をセット
                    const addDay = 7 * (weeks + 1) - 1;
                    this.roas_end_date = this.$dayjs(this.roas_start_date).endOf('date').add(addDay, 'days');

                    //終了日が未来日になった場合、昨日の日付を再セット
                    // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                    // this.roas_end_date = (this.roas_end_date < yesterday) ? this.roas_end_date : yesterday;
                }

                //日次・月次の場合
                else {
                    this.roas_end_date = this.$dayjs(date).endOf(this.roasDateUnit);
                }
            },
        },


        //表示日数のプルダウン切り替え時の処理
        rankingPeriod: {
            get: function () {
                return this.ranking_period;
            },
            set: function (period) {
                if (!period) {
                    return
                }

                this.ranking_period = period;

                if (period == 'closing-month') {
                    this.ranking_start_date = this.closingMonthStartDate;
                }
                else if (this.rankingDateUnit == 'week') {
                    this.ranking_start_date = this.baseDate().subtract(period, 'day');
                }
                else {
                    this.ranking_start_date = this.baseDate().startOf(this.rankingDateUnit).subtract(period, this.rankingDateUnit);
                }
                this.ranking_end_date = this.initStopDate;
            },
        },
        roasPeriod: {
            get: function () {
                return this.roas_period;
            },
            set: function (period) {
                if (!period) {
                    return
                }

                this.roas_period = period;

                if (period == 'closing-month') {
                    this.roas_start_date = this.closingMonthStartDate;
                }
                else if (this.roasDateUnit == 'week') {
                    this.roas_start_date = this.baseDate().subtract(period, 'day');
                }
                else {
                    this.roas_start_date = this.baseDate().startOf(this.roasDateUnit).subtract(period, this.roasDateUnit);
                }
                this.roas_end_date = this.initStopDate;
            },
        },


        closingMonthStartDate: function () {
            const now = this.baseDate()
            // 12-01
            let start = now.month(11).startOf('months')
            const stop = now.subtract(1, 'days')
            // 12-01よりまえなら去年
            if (start.isAfter(stop)) {
                start = start.subtract(1, 'years')
            }
            return start;
        },
        initStopDate: function () {
            return this.baseDate().endOf('day').subtract(1, 'days');
        },
        dateUnitList: function () {
            return [
                { label: '日次', value: DATE_UNIT_TYPE.DAY },
                { label: '週次', value: DATE_UNIT_TYPE.WEEK },
                { label: '月次', value: DATE_UNIT_TYPE.MONTH },
            ];
        },


        //「日次・週次・月次」切り替え時の日付期間リセット処理
        rankingDateUnit: {
            get: function () {
                return this.ranking_date_unit;
            },
            set: function (date_unit) {
                if (!date_unit) {
                    return
                }

                this.ranking_date_unit = date_unit;

                this.ranking_start_date = this.ranking_start_date.startOf(date_unit);
                this.ranking_end_date = this.ranking_end_date.endOf(date_unit);
                //const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                //this.ranking_end_date = (this.ranking_end_date < yesterday) ? this.ranking_end_date : yesterday;
            },
        },
        roasDateUnit: {
            get: function () {
                return this.roas_date_unit;
            },
            set: function (date_unit) {
                if (!date_unit) {
                    return
                }

                this.roas_date_unit = date_unit;

                this.roas_start_date = this.roas_start_date.startOf(date_unit);
                this.roas_end_date = this.roas_end_date.endOf(date_unit);
                // const yesterday = this.$dayjs().startOf('date').subtract(1, 'days');
                // this.roas_end_date = (this.roas_end_date < yesterday) ? this.roas_end_date : yesterday;
            },
        },
        //店舗タブ一覧（DBから取得した services/allByGroup の店舗グループを展開）
        //店舗が増減してもハードコードを修正せず追従させる
        shopTabs: function () {
            return this.servicesByGroup.shops.flatMap(group => group.services);
        },
        //店舗タブの service_id 一覧（ランキング取得・表示判定に使用）
        shopServiceIds: function () {
            return this.shopTabs.map(shop => shop.service_id);
        },
        //自社の service_id 一覧（services.js から取得）
        inHouseServiceIds: function () {
            return this.servicesByGroup.inHouses.flatMap(group => group.services.map(s => s.service_id));
        },
        //全モールの service_id 一覧（services.js から取得）
        mallServiceIds: function () {
            return this.servicesByGroup.malls.flatMap(mall => mall.services.map(s => s.service_id));
        },
        ...mapGetters({
            media: 'media/allmedia',
            servicesByGroup: 'services/allByGroup'
        }),
    }
}
</script>

<style scoped lang="sass">

.loading-window
    background: rgba(255, 255, 255, 0.8)
    height: 100%
    left: 0
    position: fixed
    top: 0
    width: 100vw
    // モーダルより手前に表示する
    z-index: 2000
    .loading-window-inner
        left: 50%
        position: absolute
        text-align: center
        top: 50%
        transform: translate(-50%, -50%)
.nopc
    display: none
.homeContents
    margin: 20px 20px 0 20px
    h2
        margin-bottom: 10px
        font-size: 1.6rem
    p
        margin-bottom: 10px
        font-size: 1.4rem
    .sort-select
        margin-left: 10px
        width: 100px;
    .homeRanking
        width: 100%
        margin-bottom: 20px
    .homeRoas
        margin-bottom: 50px
    .dispSettingItem
        margin-left: 20px
    .dispSettingItem2
        margin: 0 10px 0 20px
    .apiBox
        padding: 0.5em 1em 0.5em 0;
        margin-bottom: 2em;
        font-weight: bold;
        color: #ff7d6e;
        background: #ffebe9;
        border: solid 2px #ff7d6e;
        border-radius: 5px;
        p
            margin: 0;
            padding: 0;
        .apiDetail
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
        p
            margin-left: 20px;

.dispType
    font-size: 1.3rem
    display: flex
    justify-content: space-between
    margin: 20px 0 8px 0
    .title
        margin: 0
    .typeItemWrap
        display: flex
        justify-content: flex-end
        .typeItem
            background: $whiteColor
            cursor: pointer
            margin-right: 8px
            text-align: center
            width: 110px
            .onDisp
                background: $mainColor
                color: $whiteColor
                padding: 3px
            .offDisp
                color: #c0c0c0
                padding: 3px
            &:hover
                opacity: .6
            .totallingMenu
                color:#000
                padding: 6px
.dispMenu
    background: #3B4043;
    color: #ffffff;
    display: flex
    justify-content: space-between
    align-items: center
    flex-wrap :wrap
    font-size: 1.4rem
    margin-bottom: 10px
    padding: 10px;
    span
        display: inline-block
        vertical-align: middle
        .dispPeriodInput
            display: inline-block
    .applyBtn
        padding-left:  16px
        padding-right: 16px
    .dispLeftMenu
        margin-left: 0px
        display: flex
        align-items: baseline
        .dispDateWrap
            display: flex
            align-items: baseline
    .dispCompare
        margin-left: 8px
        display: inline-block
        vertical-align: middle
    .dispCompare_sp
        display: none
    #compare1, #compare2
        display: none
    .compareCheckBox
        line-height: 18px
        padding-left: 20px
        position: relative
        &::before
            background: $whiteColor
            border: 1px solid $grayColor
            content: ''
            cursor: pointer
            display: block
            height: 15px
            position: absolute
            width: 15px
        &::after
            border-bottom: 3px solid $mainColor
            border-right: 3px solid $mainColor
            content: ''
            cursor: pointer
            display: block
            height: 9px
            left: 5px
            margin-top: -8px
            opacity: 0
            position: absolute
            top: 50%
            transform: rotate(45deg)
            width: 5px
    #compare1:checked + .compareCheckBox::after
        opacity: 1
    #compare2:checked + .compareCheckBox::after
        opacity: 1
.dispMenu_white
    display: flex
    font-size: 1.4rem
    margin-left: 20px
    margin-bottom: 10px
    .dispLeftMenu
        margin-top: 10px
        flex: 1 1 auto
    .dispRightMenu
        flex: 1 0 auto
        text-align: right
.title
    margin-bottom: 10px
    display: flex;
    align-items: center
    justify-content: space-between;
    h2
        margin-bottom: 0
    .titleLeft
        display: flex
        align-items: center
        gap: 6px
    .scheduleTableIcon
        cursor: pointer
        display: inline-flex
        &:hover
            opacity: .6
.dataControllMenu
    width: 100%
    margin-bottom: 10px
    display: flex
    justify-content: space-between;
    align-items: center
    .dataControllLeft
        display: flex
        align-items: center
        gap: 10px
    .tooltips
            visibility: hidden
            opacity: 0
            position: absolute
            top: 100px
            z-index: 999
            padding: 10px
            background-color: $whiteColor
            border-radius: 5px
            box-shadow: 3px 3px 2px rgba(0, 0, 0, .5)
            color: $grayColor
            font-size: 1.2rem
            font-weight: normal
            transition: .3s
            line-height: 1.5
    .tooltipsHover
        &:hover .tooltips
            visibility: visible
            opacity: 1
            transition: .3s
    .mr10
        margin-right: 10px
.modal_dataUpdate
    padding: 16px 32px
    color: $grayColor
    .header
        padding: 5px
        height: 50px
        margin-bottom: 5px
        h3
            display: block
            float: left
            font-size: 20px
    .dataUpdate_period
        display: flex
        flex-direction: column
        align-items: flex-start
        gap: 8px
        margin-bottom: 16px
        .dataUpdate_periodLabel
            font-size: 1.4rem
        .dispPeriod
            display: flex
            align-items: center
            gap: 5px
    p
        font-size: 1.6rem
    .updateBtn
        width: 100px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .dataUpdate_btns
        margin-top: 40px
        display: flex
        justify-content: space-evenly
.rankingTab
    display: flex
    align-items: flex-end
    gap: 3px
    .rankingTabBtn
        display: flex
        justify-content: center
        align-items: center
        width: 100px
        height: 30px
        border: none
        background: #C0C0C0
        border-radius: 5px 5px 0 0
        color: #FFF
        font-size: 1.2rem
        cursor: pointer
        &.active
            height: 38px
            background: $grayColor
.rankingShopTab
    display: none
    gap: 4px
    width: 100%
    padding: 7px
    background: $grayColor
    &.active
        display: flex
    .rankingShopTabBtn
        display: flex
        justify-content: center
        align-items: center
        width: 90px
        height: 24px
        border: none
        background: #FFF
        border-radius: 0
        font-size: 1.1rem
        cursor: pointer
        &.active
            background: $mainColor
            color: #FFF
.rankingWrapper
    display: flex
.rankingDataContents
    display: flex
    flex-shrink: 0
    font-size: 1.4rem
    overflow-y: scroll
    overscroll-behavior: none
    width: 100%;
    height: 360px
    &::-webkit-scrollbar
        height: 12px
        width: 12px
        border-radius: 2px
        background-color: #c0c0c0
    &::-webkit-scrollbar-thumb
        border-radius: 2px
        background-color: $mainColor
.dispDataContents
    flex-shrink: 0
    font-size: 1.4rem
    max-height: 520px
    overflow: scroll
    overscroll-behavior: none
    &::-webkit-scrollbar
        height: 12px
        width: 4px
        border-radius: 2px
        background-color: #c0c0c0
    &::-webkit-scrollbar-thumb
        border-radius: 2px
        background-color: $mainColor
.rankingFooter
    margin-top: 10px
    span
        display: inline-block
        text-align: left
        vertical-align: middle
        .addBtn
            border: 1px solid $mainColor
            padding: 12px
            width: 170px
            &:hover
                border: 1px solid $mainColor
            span
                font-size: 0.3rem
.nopc
    display: none
@include sp()
    .sp
        display: none !important
    .nopc
        display: block
    .homeContents
        margin: 0
        padding: 20px 5px
        .dispType
            display: block
            justify-content: space-between
            .title 
                margin: 10px
            .typeItemWrap
                display: flex
                justify-content: flex-start
                .typeItem
                    width: 33%
                .typeItem:last-child
                    margin-right: 0
        .dispMenu
            font-size: 12px
            .applyBtn
                width: 45px
                padding: 5px 0
            .sort-select
                width: 25%
                margin: 10px 2% 0 0
                &:last-child
                    margin-right: 0
            .dispSettingItemRadio
                margin: 10px 2% 0 0
            .dispSettingItem2
                margin: 10px 10px 0 0
            .dispLeftMenu
                display: block
                .dispCompare_sp
                    display: inline-block
                    width: 25%
                    margin: 10px 0 0 0;
                    .compareCheckBox
                        &::before
                            top: 0
                            left: 0
        .dataControllMenu
            width: 100%
        .rankingTab
            .rankingTabBtn
                height: 30px
                font-size: 1.1rem
                &.active
                    height: 30px
        .rankingShopTab
            width: 100%
        .rankingWrapper
            display: block
            .rankingDataContents
                width: 100%
                height: 300px

</style>